import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging } from '../../actions/log';
import fly from '../../static/popup_notconnect.png';
import styles from './NoNet.module.less';
import { logNative } from '../../utils/utils';


const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);


  const handleRetry = useCallback(() => {
    if (window.external) {
      const onlineStr = window.external.is_net_connected() || '{}';
      try {
        const online = JSON.parse(onlineStr)
        if (online.netstatus === 1 || online.netstatus === "1") {
          logNative(`使用过程中无网络点击重试，直接刷新页面：${window.location.href}`, {});
          window.location.href = window.location.href;
        }
      }
      catch (error) {
        logNative(`window.external.is_net_connected() JSON格式错误:${window.external.is_net_connected()}`, error);
      }
    }
    // 点击重试按钮
    dispatch(
      logging({
        category: 'C',
        action: 'exception_Retry',
        label: '',
        param2: {
          source: 'exception',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          online: window.external.is_net_connected(),
        },
      }),
    );
  }, []);

  useEffect(() => {
    // 网络错误页面 PV
    dispatch(
      logging({
        category: 'P',
        action: 'exception',
        label: '',
        param2: {
          source: 'exception',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [dispatch]);

  return (
    <div className={styles.nonetWrap}>
      <div className="Img">
        <img src={fly} alt="" />
      </div>
      <div className="text">无法连接到网络</div>
      <button type="button" className="retry" onClick={handleRetry}>
        重试
      </button>
    </div>
  );
});
